
window.twitterCheckCount = 0;

window.SetUpTwitterTimeline = function () {

    check_twttr();
}

function check_twttr() {
    if (window.twitterCheckCount < 10) {
        if (typeof twttr !== 'undefined') {
            buildTimeline();
        } else {
            setTimeout(check_twttr, 500);
        }
    }
}

function buildTimeline() {
    var container = document.querySelector('.twitter-container');
    var timeline = document.querySelector('.twitter-timeline--hidden');

    if (container && timeline) {
        timeline.classList.remove('twitter-timeline--hidden');
        timeline.classList.add('twitter-timeline');
        timeline.setAttribute("href", "https://twitter.com/Legal_Ombudsman");
        //twttr.widgets.load();
        twttr.widgets.createTimeline(
            {
                sourceType: "profile",
                screenName: "Legal_Ombudsman"
            },
            timeline
        );
        container.classList.remove('hide');
    }
}

window.DestroyTwitterTimeline = function () {
    var container = document.querySelector('.twitter-container');

    if (container) {
        container.remove();
    }
}